import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/map';
import * as decode from 'jwt-decode';

@Injectable()
export class AuthGuardService implements CanActivate{

  constructor(private auth:AuthService, private router:Router) {}

    canActivate(){
      if(this.auth.isAuthenticated()){
        return true;
      }else{
        this.auth.logout();
        return false;
      }
    }
    
  } 
  
  /*canActivate(){
    
    return this.auth.isLoggedIn.map(logeado=>{
      console.log("authguard canactivate"+logeado);
      if(!logeado){
        console.log("dentro del authguard no logeado");
        this.router.navigate(["/login"]);
        return false;
      }
        return true;
    });
  }*/

  /*canActivate(){
    if(this.auth.loggedIn.value==false){
      console.log("dentro del authguard no logeado");
      this.router.navigate(['/login']);  
      return false;
    }else{
      return true;
    }
  }*/





// WEBPACK FOOTER //
// ./src/app/services/auth-guard.service.ts